<template>
  <!-- h-ekran (gt_style.css): h-screen yerine, cunku Tailwind'in 100vh'si iOS'ta gorunur
       alandan buyuk - her sayfa adres cubugu kadar kayiyordu. Icerideki "flex flex-1 min-h-0"
       satirina DOKUNULMADI (bkz. dd51216). -->
  <div class="flex flex-col h-ekran">
    <!-- Menubar -->
    <div class="admin-border-bottom">
      <Menubar v-if="MenubarVisible" class="z-50 relative">
        <template #start>
          <div class="flex items-center gap-2">
            <router-link to="/admin/main" class="inline-flex items-center h-10 shrink-0 cursor-pointer">
              <img alt="logo" :src="SirketLogo" class="block h-8 max-h-8 w-auto max-w-[170px] object-contain"
                @error="onLogoError" />
            </router-link>
            <button
              v-if="isMobile && !lisansYok"
              class="p-2 rounded hover:bg-gray-100"
              @click="toggleMobileMenu($event)"
            >
              <i class="pi pi-bars text-xl"></i>
            </button>
          </div>
        </template>
        <template #end>
          <div class="flex items-center gap-2">
            <!-- Sparqon giris noktasi. Butonu AIMessenger buraya Teleport ile basar; boylece
                 buton ve panel ayni async chunk'ta kalir, lisanssiz sirket hicbir Sparqon
                 kodu indirmez (bkz. asagidaki defineAsyncComponent + v-if="sparqonLisansVar"). -->
            <div id="sparqon-bar-yuvasi" class="flex items-center"></div>

            <!-- ZK1 (2026-09-25): Sparqon lisanslı şirkette zil HİÇ render edilmez — bildirimler
                 Sparqon'un içinde (birleşik rozet + Home'daki her zaman görünen bildirim satırı →
                 SparqonBildirimDialog → "Bildirim geçmişini gör"). Lisanssız şirkette Sparqon
                 düğmesi olmadığı için zil tek bildirim girişi, birebir eskisiyle aynı kalır. -->
            <div v-if="!sparqonLisansVar" ref="notifContainer" class="relative flex items-center">
              <button
                type="button"
                class="relative inline-flex items-center justify-center w-9 h-9 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors focus:outline-none"
                :aria-expanded="showNotif"
                aria-haspopup="true"
                tabindex="0"
                @click.stop="toggleNotifPanel()"
                @keydown.escape="showNotif = false"
              >
                <i class="pi pi-bell text-xl"></i>
                <span
                  v-if="unreadCount > 0"
                  class="absolute -top-1 -right-1 dolgu-olumlu text-white text-[11px] font-bold rounded-full min-w-[18px] h-4 flex items-center justify-center px-1.5"
                >
                  {{ unreadCount }}
                </span>
              </button>

              <transition
                enter-active-class="transition duration-150 ease-out transform"
                enter-from-class="opacity-0 -translate-y-1 scale-95"
                enter-to-class="opacity-100 translate-y-0 scale-100"
                leave-active-class="transition duration-100 ease-in transform"
                leave-from-class="opacity-100 translate-y-0 scale-100"
                leave-to-class="opacity-0 -translate-y-1 scale-95"
              >
                <div
                  v-if="showNotif"
                  :style="{ borderColor: ui.koyuTema ? '#4b5563' : '#CBD5E1' }"
                  class="absolute right-0 top-full mt-2 w-96 max-sm:fixed max-sm:left-3 max-sm:right-3 max-sm:top-14 max-sm:w-auto bg-surface-0 dark:bg-surface-800 !rounded-lg shadow-md dark:shadow-lg border !border-gray-300 dark:!border-gray-600 z-50"
                >
                  <div
                    class="flex items-center justify-between px-3 py-2 border-b !border-gray-300 dark:!border-gray-600"
                  >
                    <div class="flex items-center gap-2">
                      <span class="font-semibold text-sm">Bildirimler</span>
                      <span
                        v-if="unreadCount"
                        class="text-xs text-gray-500 dark:text-gray-400"
                        >({{ unreadCount }} okunmamış)</span
                      >
                    </div>
                    <Button
                      v-if="unreadCount > 0"
                      text
                      @click.stop="markAllRead"
                    >Tümünü Oku</Button>
                  </div>

                  <div class="max-h-80 overflow-y-auto">
                    <div
                      v-if="notifications.length === 0"
                      class="p-4 text-center text-sm text-gray-500 dark:text-gray-400"
                    >
                      Bildirim yok
                    </div>

                    <div class="divide-y divide-gray-200 dark:divide-gray-700">
                      <BildirimSatiri
                        v-for="notif in notifications"
                        :key="notif.id"
                        :notif="notif"
                        sikisik
                        @tikla="openNotif"
                      />
                    </div>
                  </div>
                  <div class="border-t border-gray-300 dark:border-gray-600 p-2">
                    <Button
                      severity="info"
                      text
                      class="w-full"
                      @click.stop="openNotifDialog()"
                    ><i class="pi pi-external-link"></i> Tümünü Gör</Button>
                  </div>
                </div>
              </transition>
            </div>

            <Button
              severity="warn"
              text
              @click="toggleUserMenu"
            >
              <i class="pi pi-user"></i>
              <!-- Dar ekranda ad gizlenir: ust barda artik Sparqon butonu da var, 375px'te sigmiyordu. -->
              <span class="hidden sm:inline">{{ KullaniciBilgi?.AdSoyad || '---' }}</span>
            </Button>
            <Menu ref="userMenu" :model="menuPopupItems" :popup="true">
              <!-- OT-4: "Çıkış" ipucu (K3 — tüm cihazlardan çıkış) -->
              <template #item="{ item, props }">
                <a v-bind="props.action" :title="item.ipucu || null">
                  <span v-if="item.icon" :class="[item.icon, 'p-menu-item-icon']" />
                  <span class="p-menu-item-label">{{ item.label }}</span>
                </a>
              </template>
            </Menu>
          </div>
        </template>
      </Menubar>
    </div>

    <div class="flex flex-1 min-h-0">
      <!-- Desktop Sol Menü -->
      <div
        v-if="!isMobile && !lisansYok"
        class="admin-sidebar hidden md:flex md:w-2/12 h-full flex-col bg-surface-0 dark:bg-surface-900 admin-border-right relative"
        style="z-index: 60"
      >
        <!-- Arama kutusu -->
        <div class="p-2 admin-border-bottom shrink-0">
          <div
            class="admin-search-box flex items-center gap-2 px-3 py-2 rounded-lg bg-surface-50 dark:bg-surface-800 focus-within:ring-1 transition-all"
          >
            <i
              class="pi pi-search text-gray-400"
              style="font-size: 13px; flex-shrink: 0"
            ></i>
            <!-- autocomplete="off" sifre yoneticileri tarafindan yok sayiliyor; asagidaki
                 isaretler olmadan Sifre Degistir ekraninda bu kutuya kullanici adi
                 dolduruluyordu (menu filtrelenip "Sonuc bulunamadi" cikiyordu). -->
            <input
              v-model="searchQuery"
              type="text"
              name="menuArama"
              autocomplete="off"
              data-1p-ignore
              data-lpignore="true"
              data-form-type="other"
              placeholder="Menüde ara..."
              class="flex-1 text-sm bg-transparent outline-none text-gray-700 dark:text-gray-200 placeholder-gray-400 min-w-0"
            />
            <i
              v-if="searchQuery"
              class="pi pi-times text-gray-400 hover:text-gray-600 cursor-pointer transition-colors"
              style="font-size: 11px; flex-shrink: 0"
              @click="searchQuery = ''"
            ></i>
          </div>
        </div>

        <!-- Menü alanı (scrollable) -->
        <div class="flex-1 min-h-0 overflow-y-auto custom-scrollbar">
        <!-- Menu henuz gelmedi (_GetNavbar donene kadar): bos TieredMenu yerine iskelet -
             sol menu bir an "hicbir sey yok" gibi gorunmesin. -->
        <div v-if="!searchQuery && items.length === 0" class="p-3 flex flex-col gap-3">
          <Skeleton v-for="i in 7" :key="i" width="100%" height="1.75rem" border-radius="8px" />
        </div>

        <!-- Normal TieredMenu (arama yokken) — inline, submenus hover anında overflow kırpmadan kaçar -->
        <TieredMenu
          v-else-if="!searchQuery"
          :model="items"
          class="border-none w-full"
          :pt="{
            itemContent: ({ item }) => ({
              class: [
                item?.severity === 'danger' ? 'menu-danger' : null,
                item?._active ? 'menu-active' : null,
              ].filter(Boolean).join(' ') || null,
            }),
          }"
        >
          <template #item="{ item, props, hasSubmenu }">
            <router-link
              v-if="!hasSubmenu && item.url && item.url.startsWith('/')"
              v-slot="{ href, navigate }"
              :to="item.url"
              custom
            >
              <a :href="href" v-bind="props.action" @click="navigate">
                <span v-bind="props.icon" />
                <span v-bind="props.label">{{ item.label }}</span>
              </a>
            </router-link>
            <a v-else v-bind="props.action">
              <span v-bind="props.icon" />
              <span v-bind="props.label">{{ item.label }}</span>
              <span v-if="hasSubmenu" v-bind="props.submenuicon" class="pi pi-angle-right" />
            </a>
          </template>
        </TieredMenu>

          <!-- Düz arama sonuçları (arama varken) -->
          <div v-else class="pb-16">
            <template v-if="flatFilteredItems.length > 0">
              <a
                v-for="item in flatFilteredItems"
                :key="item.url + item.label"
                :href="item.url"
                class="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors cursor-pointer border-b border-gray-50 dark:border-gray-800"
                @click.prevent="navigateTo(item.url)"
              >
                <i
                  :class="item.icon"
                  class="text-gray-400"
                  style="font-size: 14px; width: 16px; text-align: center"
                ></i>
                <div class="flex flex-col min-w-0">
                  <span class="truncate" v-html="highlight(item.label)"></span>
                  <span v-if="item.breadcrumb" class="text-xs text-gray-400 truncate">{{
                    item.breadcrumb
                  }}</span>
                </div>
              </a>
            </template>
            <div
              v-else
              class="flex flex-col items-center justify-center py-10 text-gray-400"
            >
              <i class="pi pi-search mb-2" style="font-size: 22px"></i>
              <p class="text-xs">
   Sonuç bulunamadı
   </p>
            </div>
          </div>
        </div>

        <!-- Alt bilgi -->
        <div
          class="admin-sidebar-footer shrink-0 p-3 text-center text-sm text-gray-600 dark:text-gray-400 admin-border-top bg-surface-0 dark:bg-surface-900 flex items-center gap-2"
        >
          <!-- MOB M1-T: Android uygulaması indirme (uygulamanın içinde gizli — zaten kurulu) -->
          <a
            v-if="!yerelUygulama"
            :href="apkAdresi"
            class="shrink-0 w-9 h-9 rounded-lg flex items-center justify-center renk-olumlu dark:hover:bg-gray-800"
            title="Android uygulamasını indir"
            aria-label="Android uygulamasını indir"
          >
            <i class="pi pi-android" style="font-size: 1.25rem"></i>
          </a>
          <div class="flex-1 min-w-0 flex flex-col gap-1">
            <div
              class="font-semibold text-gray-800 dark:text-gray-200 text-xs tracking-wide"
            >
              {{ KullaniciBilgi?.SubeAd || "---" }}
            </div>
            <div class="text-[11px] text-gray-400 dark:text-gray-500">
              {{ new Date().toLocaleDateString("tr-TR") }} - {{ beyazEtiketAcik && sirketMarkaAdi ? sirketMarkaAdi : "Hepy.app" }}
            </div>
          </div>
        </div>
      </div>

      <!-- Ana içerik -->
      <div
        :class="['flex-1 overflow-auto relative', RouterView]"
        style="overflow-anchor: auto; scroll-behavior: smooth"
      >
        <!-- Oturum ici sayfa gecisi göstergesi: router-view'ın kardeşi, navbar/Sparqon'un
             ÜSTÜNE değil yalnız bu içerik alanının üstüne biner (bkz. NavProgressBar.vue). -->
        <NavProgressBar v-if="ui.navLoading" />
        <!-- MOB M1-3: mobil uygulamada ağır ekran uyarısı (web'de render etmez) -->
        <MasaustuUyarisi v-if="yerelUygulama" />
        <!-- MDK-5: dolgu h-full kutunun alt kenarında kalıyordu; uzun sayfada son satır alt çubuğun /
             FAB'ın / Android gezinme çubuğunun altında kalıyordu. Sayfanın arkasına boşluk bloğu
             (+ alt güvenli alan) konur. Ekranı dolduran sayfa (meta.tamYukseklik) eski dolguyla kalır —
             blok orada fazladan kaydırma açardı. -->
        <div :class="['h-full p-3 sm:p-4', $route.meta.tamYukseklik ? 'pb-24 sm:pb-24' : 'pb-0 sm:pb-0']">
          <ImpersonasyonSeridi />
          <DuyuruSeridi />
          <LisansUyariSeridi />
          <SayfaBasligiAlani ref="sbAlani" :menu="items" />
          <!-- Sayfa layout'un div'iyle sarılır: sayfa kökü çok köklü olsa da geçiş tek element
               görür (SB6). Anahtar route kaydı: kayıt değişince geçiş + before-enter çalışır;
               fullPath değil, yalnız parametre/sorgu değişiminde sayfa yeniden kurulmaz.
               Sekme gizliyken (SB6-R): :css false + onLeave microtask'ta done() çağırır — senkron
               done() unmount sırasında koptuğu DOM'a erişip çöküyordu (SB6 karar 24'te görüldü). -->
          <router-view v-slot="{ Component, route }">
            <transition :name="sayfaGecisAdi" v-bind="gizliSekmeGecisi" mode="out-in" @before-enter="_sbRouteGuncelle">
              <!-- BSL-D1 (B-4): h-full kutudan taşan içerik alt boşluğun üstüne biniyordu (son düğme köşe
                   hapının / FAB'ın altında kalıyordu). Tam yükseklik sayfası dışında kutu içerikle uzar. -->
              <div v-if="Component" :key="route.matched[route.matched.length - 1].path" :class="route.meta.tamYukseklik ? 'h-full' : 'min-h-full'">
                <component :is="Component" />
              </div>
            </transition>
          </router-view>
          <div v-if="!$route.meta.tamYukseklik" class="sayfa-alt-bosluk" aria-hidden="true"></div>
        </div>
      </div>

      <!-- Mobil Popup TieredMenu -->
      <TieredMenu ref="mobileMenu" :model="items" class="w-full" :popup="true">
          <template #item="{ item, props, hasSubmenu }">
            <router-link
              v-if="!hasSubmenu && item.url && item.url.startsWith('/')"
              v-slot="{ href, navigate }"
              :to="item.url"
              custom
            >
              <a :href="href" v-bind="props.action" @click="navigate">
                <span v-bind="props.icon" />
                <span v-bind="props.label">{{ item.label }}</span>
              </a>
            </router-link>
            <a v-else v-bind="props.action">
              <span v-bind="props.icon" />
              <span v-bind="props.label">{{ item.label }}</span>
              <span v-if="hasSubmenu" v-bind="props.submenuicon" class="pi pi-angle-right" />
            </a>
          </template>
      </TieredMenu>
    </div>

    <AIMessenger v-if="sparqonLisansVar" @bildirim-tarihce-ac="openNotifDialog('left')" />

    <!-- BSL-PENCERE: kurulum penceresi + köşe hapı, «Örnekle başla» önizlemesi, ekran turu balonu -->
    <KurulumPenceresi />
    <KurulumHapi />
    <OrnekOnizleme />
    <TurBalonu />

    <!-- IZ-N: NPS anketi (sağ-alt; gösterim kararı BE GetNpsDurum) -->
    <NpsKart />

    <!-- Tek kök ConfirmDialog — tüm private sayfalardaki $confirm.require çağrıları bunu kullanır -->
    <ConfirmDialog />
    <!-- KDU: kaydedilmemiş değişiklik onayı (services/kirliKayit.js) — silme onaylarıyla çakışmasın diye ayrı grup -->
    <ConfirmDialog group="kirli" />

    <Drawer
      v-model:visible="showNotifDialog"
      :position="bildirimPanelKonum"
      :modal="bildirimPanelKonum === 'right'"
      :dismissable="bildirimPanelKonum === 'right'"
      :style="{ width: '32rem', maxWidth: '100vw' }"
    >
      <template #header>
        <div>
          <div class="font-bold text-base"><i class="pi pi-bell mr-2"></i>Tüm Bildirimler</div>
          <SelectButton
            v-model="bildirimSekme"
            :options="bildirimSekmeSecenekleri"
            option-label="label"
            option-value="value"
            :allow-empty="false"
            class="mt-2"
          />
        </div>
      </template>

      <div v-if="bildirimlerYukleniyor" class="p-8 text-center text-sm text-gray-500 dark:text-gray-400">
        Yükleniyor…
      </div>
      <div
        v-else-if="panelListesi.length === 0"
        class="p-8 text-center text-sm text-gray-500 dark:text-gray-400"
      >
        {{ bildirimSekme === "okunmamis" ? "Okunmamış bildirim yok" : "Bildirim yok" }}
      </div>
      <div v-else>
        <div v-for="grup in panelGruplari" :key="grup.baslik">
          <div class="px-4 pt-3 pb-1 text-xs font-semibold text-gray-500 dark:text-gray-400">{{ grup.baslik }}</div>
          <div class="divide-y divide-gray-200 dark:divide-gray-700">
            <BildirimSatiri
              v-for="notif in grup.liste"
              :key="notif.id"
              :notif="notif"
              @tikla="openNotif"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <div class="flex items-center justify-between gap-4">
          <span v-if="bildirimSekme === 'tumu'" class="text-sm text-gray-500 dark:text-gray-400">
            {{ allNotifications.length >= 200 ? "Son 200 bildirim gösteriliyor" : `Toplam ${allNotifications.length} bildirim` }}
          </span>
          <span v-else></span>
          <Button
            v-if="okunmamisSayisi > 0"
            class="rounded-xl px-3"
            @click="markAllRead"
          ><i class="pi pi-check"></i> Tümünü Oku</Button>
        </div>
      </template>
    </Drawer>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { temaUygula, kayitliTema, temaDbden } from "@/services/tema";
import { boyutUygula, boyutDbden } from "@/services/alanBoyutu";
import { uiState, menuTtlDoldu } from "@/services/uiState";
import { yetkiYenidenKontrolMuafMi } from "@/services/rotaMuafiyet";
import { onaySorucuAyarla, onaySorucuKaldir, confirmSorucusu, kirliVarMiHemen, cikisOnayiAl, defteriBosalt } from "@/services/kirliKayit";
import { bildirimRotasi, bildirimDonustur, bildirimTarihGrubu } from "@/services/bildirimYonlendirme";
import { yardimliSayfalarTazele } from "@/services/yardim";
import { getAktifLisanslar } from "@/services/lisans";
import BildirimSatiri from "@/components/Bildirim/BildirimSatiri.vue";
import SayfaBasligiAlani from "@/components/HelperLayout/SayfaBasligiAlani.vue";
import LisansUyariSeridi from "@/components/HelperLayout/LisansUyariSeridi.vue";
import ImpersonasyonSeridi from "@/components/HelperLayout/ImpersonasyonSeridi.vue";
import DuyuruSeridi from "@/components/HelperLayout/DuyuruSeridi.vue";
import NpsKart from "@/components/HelperLayout/NpsKart.vue";
import MasaustuUyarisi from "@/components/HelperLayout/MasaustuUyarisi.vue";
import KurulumPenceresi from "@/components/Baslarken/KurulumPenceresi.vue";
import KurulumHapi from "@/components/Baslarken/KurulumHapi.vue";
import OrnekOnizleme from "@/components/Baslarken/OrnekOnizleme.vue";
import TurBalonu from "@/components/Baslarken/TurBalonu.vue";
import { bsl, durumYukle, pencereAc } from "@/baslarken/durum";
import { hatAdimlari } from "@/baslarken/hatlar";
import { yerelUygulama } from "@/services/platform";
import { API_KOK } from "@/services/apiAdres";

// Sparqon 10 bilesene ayrildi + XLSX/file-saver tasiyor. Sparqon lisansi olmayan sirketlerde
// (v-if="sparqonLisansVar") hic render edilmiyor; async import ile o kullanicilar chunk'i
// indirmiyor, lisansli kullanicilar da ilk boyamayi beklemiyor.
const AIMessenger = defineAsyncComponent(() => import("@/components/AI/AIMessenger.vue"));

export default {
  components: { AIMessenger, BildirimSatiri, SayfaBasligiAlani, LisansUyariSeridi, ImpersonasyonSeridi, DuyuruSeridi, NpsKart, MasaustuUyarisi, KurulumPenceresi, KurulumHapi, OrnekOnizleme, TurBalonu },

  data() {
    const logoFallback = require("@/assets/logo/logo2.png");
    const gecerli = (v) => !!v && (v.startsWith("http") || v.startsWith("data:") || v.startsWith("/"));
    const cachedLogo = localStorage.getItem("sirketLogo");
    return {
      yerelUygulama,
      apkAdresi: API_KOK + "MobilApk",
      ui: uiState,
      bsl,
      // prefers-reduced-motion altında transition'ı CSS ile (transition:none) sıfırlamak yerine
      // isim değiştiriyoruz: eşleşen bir CSS kuralı olmadığında Vue <transition> geçiş/animasyon
      // süresini 0 bulup mode="out-in" swap'ını hemen çözüyor — NavProgressBar/LoadingScreen/
      // WaitSkeleton'daki media-query tabanlı yaklaşımdan farklı, ama tek kod yolu (iki class seti
      // yerine tek CSS bloğu) daha az tekrar demek.
      sayfaGecisAdi: window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "gecis-yok" : "sayfa",
      // SB6-R: sekme gizliyken requestAnimationFrame çalışmaz, CSS geçişi hiç bitmez (gövde eski
      // sayfada donmuş görünür). gizliSekmeGecisi computed'i bu durumda :css=false + microtask'lı
      // done() uygular (bkz. methods._gizliSekmeLeave).
      sekmeGizli: document.visibilityState === "hidden",
      windowWidth: window.innerWidth,
      MenubarVisible: true,
      RouterView: "w-full md:w-10/12",
      isMobile: false,
      aiLisansVar: false,
      sparqonLisansVar: false,
      sistemKonsolErisimVar: false,
      menuYukleniyor: false,
      logoFallback,
      // Yenilemede anında görünsün: yalnız GEÇERLİ cache, yoksa paketli logo (API dönünce güncellenir)
      SirketLogo: gecerli(cachedLogo) ? cachedLogo : logoFallback,
      beyazEtiketAcik: false,
      sirketMarkaAdi: "",
      KullaniciBilgi: {},
      // SAT-U: aktif lisansı olmayan şirkette sol menü boş kalıyordu — gizlenir (Satın Al /
      // Çağrılarım üst menüden). İlk lisans açılınca (sayfa yenilenir ya da menü tazelenir) geri gelir.
      lisansYok: false,
      searchQuery: "",
      showNotif: false,
      showNotifDialog: false,
      bildirimPanelKonum: "right",
      bildirimSekme: "tumu",
      bildirimlerYukleniyor: false,
      items: [],
      notifications: [],
      allNotifications: [],
      okunmamisBildirimler: [],
      unreadCount: 0,
      items_popup: [
        {
          label: "Ayarlar",
          icon: "pi pi-cog",
          command: () => this.$router.push("/kullanici/ayarlar"),
        },
        {
          label: "Çağrılarım",
          icon: "pi pi-question-circle",
          command: () => this.$router.push("/cagri/cagrilarim"),
        },
        {
          label: "Lisans Satın Al",
          icon: "pi pi-shopping-cart",
          command: () => this.$router.push("/lisans/satinal"),
        },
        { separator: true },
        { label: "Çıkış", icon: "pi pi-sign-out", ipucu: "Tüm cihazlardan çıkış yapar", command: () => this.Logout() },
      ],
    };
  },

  computed: {
    // Sistem Konsolu (SK-0 / Faz 1): yalniz saglayici kullaniciya görünür — asil erisim kontrolu
    // router guard'da (fail-closed), bu yalnizca linkin görünürlügü icin.
    menuPopupItems() {
      const items = [...this.items_popup];
      // BSL-PENCERE: «Başlarken» kurulum penceresini açar, kapatılmışsa geri açar (sağlayıcı/lisanssız şirkette yok).
      if (this.bsl.durum && !this.bsl.durum.Gizli) {
        items.unshift({
          label: "Başlarken",
          icon: "pi pi-flag",
          command: () => pencereAc("ANA"),
        });
      }
      if (this.sistemKonsolErisimVar) {
        items.splice(items.length - 2, 0, {
          label: "Sistem Konsolu",
          icon: "pi pi-shield",
          command: () => this.$router.push("/sistem/genel"),
        });
      }
      return items;
    },
    // Sekme gizliyken transition'a :css=false + özel onLeave bağlanır (SB6-R); görünürken boş obje
    // döner, transition normal CSS animasyonuyla çalışır.
    gizliSekmeGecisi() {
      return this.sekmeGizli ? { css: false, onLeave: this._gizliSekmeLeave } : {};
    },
    // Tüm menüyü düzleştirip filtreler, breadcrumb ekler
    flatFilteredItems() {
      const q = this.searchQuery.toLowerCase().trim();
      if (!q) return [];
      const result = [];
      this._flattenItems(this.items, q, [], result);
      return result;
    },

    okunmamisSayisi() {
      return this.okunmamisBildirimler.length;
    },
    bildirimSekmeSecenekleri() {
      const etiket = this.bildirimlerYukleniyor ? "Okunmamış" : `Okunmamış (${this.okunmamisSayisi})`;
      return [
        { label: "Tümü", value: "tumu" },
        { label: etiket, value: "okunmamis" },
      ];
    },
    // Sekmeye göre kaynak: Tümü -> allNotifications (200 sınırlı), Okunmamış -> okunmamisBildirimler
    // (ayrı uçtan, sınırsız - bkz. plan §2.5 "ayrı uçtan beslenir").
    panelListesi() {
      return this.bildirimSekme === "okunmamis" ? this.okunmamisBildirimler : this.allNotifications;
    },
    // Kovalama: dört grup sabit sırada, grup içinde BE'nin döndürdüğü dtOlusturma DESC sırası korunur.
    panelGruplari() {
      const gruplar = { "Bugün": [], "Dün": [], "Bu hafta": [], "Daha eski": [] };
      this.panelListesi.forEach((n) => {
        gruplar[bildirimTarihGrubu(n.tarih)].push(n);
      });
      return Object.keys(gruplar)
        .filter((k) => gruplar[k].length > 0)
        .map((k) => ({ baslik: k, liste: gruplar[k] }));
    },
  },

  mounted() {
    // KDU: router guard'ı ve Dialog formları bu sorucu üzerinden ConfirmDialog group="kirli"'yi açar
    this._kirliSorucu = confirmSorucusu(this.$confirm);
    onaySorucuAyarla(this._kirliSorucu);
    window.addEventListener("resize", this.onResize);
    window.addEventListener("sirket-logo-degisti", this._LogoDegisti); // IBS-2: İşletme Bilgileri logo kaydı
    this._GetNavbar();
    this._GetSirketBilgi();
    this._KullaniciBilgisi();
    this._GetKullaniciProfilBilgi();
    this._GetOkunmamisBildirimler();
    this._AiLisansKontrol();
    this._SistemKonsolErisimKontrol();
    yardimliSayfalarTazele();
    this._baslarkenBaslat();
    // Bildirimleri periyodik tazele (yeni bildirim sayfa yenilemeden görünür)
    this._notifTimer = setInterval(this._GetOkunmamisBildirimler, 60000);
    this.onResize();
    this.$nextTick(this._bindMenuScrollHack);
    // NB planı tetikleyici 3: sekme tekrar görünür/odaklı olduğunda TTL kontrolü (afterEach'teki
    // gezinme tabanlı kontrolün tamamlayıcısı — kullanıcı sekmeyi açık bırakıp geri dönebilir).
    document.addEventListener("visibilitychange", this._menuOdakKontrol);
    window.addEventListener("focus", this._menuOdakKontrol);
    document.addEventListener("visibilitychange", this._sekmeGizliGuncelle);
  },

  watch: {
    $route: {
      handler: '_onRouteChange',
      immediate: true,
    },
    'ui.menuTazeleGerekli'(yeni) {
      if (yeni) { this._GetNavbar(); this._lisansDurumuGuncelle(); }
    },
  },

  beforeUnmount() {
    onaySorucuKaldir(this._kirliSorucu);
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("sirket-logo-degisti", this._LogoDegisti);
    if (this._notifTimer) clearInterval(this._notifTimer);
    this._unbindMenuScrollHack();
    document.removeEventListener("visibilitychange", this._menuOdakKontrol);
    window.removeEventListener("focus", this._menuOdakKontrol);
    document.removeEventListener("visibilitychange", this._sekmeGizliGuncelle);
  },

  methods: {
    // out-in geçişte eski sayfa DOM'dan çıktıktan, yeni sayfa DOM'a girmeden hemen önce
    // tetiklenir — SayfaBasligiAlani'nın gosterilenRoute'unu burada güncellemek, başlığın
    // yeni route'a ekrandaki sayfa değişmeden önce atlamasını (flaş) önler (SB §3.2).
    _sbRouteGuncelle() {
      this.$refs.sbAlani?.routeGuncelle(this.$route);
    },
    _sekmeGizliGuncelle() {
      this.sekmeGizli = document.visibilityState === "hidden";
    },
    // Vue'nun out-in transition'ı done()'ı senkron çağrılırsa eski düğümün unmount'u sırasında
    // koptuğu DOM'a erişip çöküyor (null.parentNode / nextSibling). done'ı bir microtask sonraya
    // erteleyip bu çakışmayı önler — iki parametreli imza şart, yoksa Vue done'ı yine senkron çağırır.
    _gizliSekmeLeave(el, done) {
      Promise.resolve().then(done);
    },
    _bindMenuScrollHack() {
      const area = this.$el.querySelector(".custom-scrollbar");
      if (!area) return;
      this._onMenuEnter = () => { area.style.overflow = "visible"; };
      this._onMenuLeave = () => { area.style.overflow = "auto"; };
      area.addEventListener("mouseenter", this._onMenuEnter);
      area.addEventListener("mouseleave", this._onMenuLeave);
    },
    _unbindMenuScrollHack() {
      const area = this.$el.querySelector(".custom-scrollbar");
      if (!area) return;
      if (this._onMenuEnter) area.removeEventListener("mouseenter", this._onMenuEnter);
      if (this._onMenuLeave) area.removeEventListener("mouseleave", this._onMenuLeave);
    },

    // Menüyü düz listeye çevirir, label araması yapar, breadcrumb üretir
    _flattenItems(items, q, parents, result) {
      for (const item of items) {
        if (item.separator || !item.label) continue;

        if (item.items && item.items.length) {
          // Üst menü — çocuklara in
          this._flattenItems(item.items, q, [...parents, item.label], result);
        } else {
          // Yaprak menü — label eşleşiyorsa ekle
          if (item.label.toLowerCase().includes(q)) {
            result.push({
              label: item.label,
              icon: item.icon || "pi pi-circle",
              url: item.url || "#",
              breadcrumb: parents.join(" › "),
            });
          }
        }
      }
    },

    // BSL §8: lisans kontrolünden sonra durum; karşılama yalnız ilk girişte (KarsilamaGoster) bir kez.
    // BSL-PENCERE: karşılama kurulum penceresinin ilk ekranı; yapılacak adım ve soru yoksa açılmaz.
    _baslarkenBaslat() {
      getAktifLisanslar().then((s) => {
        if (!s || s.size === 0) return;
        durumYukle().then((d) => {
          if (d && !d.Gizli && d.KarsilamaGoster && !this.$route.path.startsWith("/sistem")
              && (d.SoruSor || hatAdimlari(d, "ANA").some((a) => !a.bitti))) {
            pencereAc("ANA", "karsilama");
          }
        });
      }).catch(() => {});
    },

    _lisansDurumuGuncelle() {
      // getAktifLisanslar tek promise ile cache'li — her geçişte istek atmaz.
      getAktifLisanslar().then((s) => { this.lisansYok = s.size === 0; }).catch(() => {});
    },

    _onRouteChange() {
      this._lisansDurumuGuncelle();
      this._markActiveMenu();
      // sayfa değişince menü aramasında önceki (ör. tarayıcı autofill kaynaklı) değer kalmasın
      this.searchQuery = "";
      // Sol panel (Sparqon soldan açıkken) Sparqon içindeki bir bağlantıyla da kapanabilir -
      // kapatılmazsa yeni sayfanın üstünde açık kalırdı (bkz. plan §2.2 "Kapanma: sayfa değişimi").
      this.showNotifDialog = false;
    },

    _markActiveMenu() {
      var path = this.$route.path;
      this._setActiveRecursive(this.items, path);
    },

    _setActiveRecursive(items, path) {
      if (!items) return;
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.separator) continue;
        item._active = !!item.url && item.url !== '#' && path.startsWith(item.url);
        if (item.items) this._setActiveRecursive(item.items, path);
      }
    },

    // Eşleşen kısmı sarı renkle vurgular
    highlight(label) {
      const q = this.searchQuery.trim();
      if (!q) return label;
      const idx = label.toLowerCase().indexOf(q.toLowerCase());
      if (idx === -1) return label;
      return (
        label.slice(0, idx) +
        `<mark class="zemin-uyari rounded px-0.5">${label.slice(
          idx,
          idx + q.length
        )}</mark>` +
        label.slice(idx + q.length)
      );
    },

    fixUrl(url) {
      if (!url) return url;
      var match = url.match(/^([^:?]*)(.*)/);
      return match[1].toLowerCase() + match[2];
    },

    navigateTo(url) {
      if (!url || url === "#") return;
      this.searchQuery = "";
      // router-link url formatına göre ayarla
      if (url.startsWith("/")) {
        this.$router.push(url);
      } else {
        window.location.href = url;
      }
    },

    toggleUserMenu(event) {
      this.$refs.userMenu.toggle(event);
    },
    toggleMobileMenu(event) {
      this.$refs.mobileMenu.toggle(event);
    },
    toggleNotifPanel() {
      this.showNotif = !this.showNotif;
      if (this.showNotif) {
        this.$nextTick(() => {
          document.addEventListener("click", this._closeNotifOutside);
        });
      } else {
        document.removeEventListener("click", this._closeNotifOutside);
      }
    },
    _closeNotifOutside(event) {
      const el = this.$refs.notifContainer;
      if (el && !el.contains(event.target)) {
        this.showNotif = false;
        document.removeEventListener("click", this._closeNotifOutside);
      }
    },
    // Bir bildirim id'si okundu işaretlenince üç listedeki (dropdown/Tümü/Okunmamış) eşleşen
    // nesneler AYRI kopyalar - üçü de openNotifDialog'un iki ayrı uçtan doldurduğu farklı
    // map() sonuçları. Okunmamış sekmesinden hemen düşürme burada (K3).
    _bildirimOkunduIsaretle(notif) {
      notif.read = true;
      const dropdown = this.notifications.find((n) => n.id === notif.id);
      if (dropdown) dropdown.read = true;
      const tumu = this.allNotifications.find((n) => n.id === notif.id);
      if (tumu) tumu.read = true;
      this.okunmamisBildirimler = this.okunmamisBildirimler.filter((n) => n.id !== notif.id);
    },
    openNotif(notif) {
      if (!notif.read) {
        if (this.sparqonLisansVar) {
          // POST'u sparqonEylem atar (sparqonDurum.bildirimler'den de o düşürür) - burada AYRICA
          // istek atmayız, "tek istek" kuralı (bkz. plan §2.5, T9). Dinamik import: lisanssız
          // şirket zaten bu dalı hiç çalıştırmaz ama chunk yine de yalnız gerektiğinde iner.
          import("@/services/sparqonDurum.js")
            .then(({ sparqonEylem }) => sparqonEylem.bildirimOku(notif))
            .then((res) => {
              if (res?.status === 200) this._bildirimOkunduIsaretle(notif);
            });
        } else {
          this.$Servis("POST", "SetBildirimOkundu", { Bildirim_rowid: notif.id })
            .then((res) => {
              if (res?.status === 200) {
                // Hızlı çift tıkta iki istek gidebilir - sayı yalnız İLK yanıtta düşsün.
                if (!notif.read) this.unreadCount = Math.max(0, this.unreadCount - 1);
                this._bildirimOkunduIsaretle(notif);
              }
            })
            .catch(() => {});
        }
      }
      const rota = bildirimRotasi(notif);
      if (rota) {
        this.$router.push(rota);
        this.showNotif = false;
        this.showNotifDialog = false;
        document.removeEventListener("click", this._closeNotifOutside);
        // Dar ekranda (itme bandı altı) Sparqon paneli de kapanır - T12/K4-②, gotoRota ile aynı kural.
        if (this.sparqonLisansVar && window.innerWidth < 1280) {
          import("@/services/sparqonDurum.js").then(({ sparqonEylem }) => sparqonEylem.kapat());
        }
      }
      // Rota yoksa hiçbir pencere kapanmaz (T11) - yalnız okundu işaretlenir.
    },
    markAllRead() {
      const istek = this.sparqonLisansVar
        ? import("@/services/sparqonDurum.js").then(({ sparqonEylem }) => sparqonEylem.bildirimlerTumunuOku())
        : this.$Servis("GET", "SetTumBildirimlerOkundu", "");
      istek.then((res) => {
        if (res?.status === 200) {
          this.notifications = [];
          this.allNotifications.forEach((n) => (n.read = true));
          this.okunmamisBildirimler = [];
          this.unreadCount = 0;
        }
      }).catch(() => {
        this.$toast.add({ severity: "error", summary: "Hata", detail: "Bir hata oluştu", life: 3000 });
      });
    },

    _GetOkunmamisBildirimler() {
      // Sparqon lisanslı şirkette bu veriyi sparqonDurum.js'in kendi 60sn'lik _rozetTimer'ı
      // çekiyor (birleşik rozet için) — burada TEKRAR çekmek "tek yoklama" kuralını bozardı.
      if (this.sparqonLisansVar) return;
      this.$Servis("GET", "GetOkunmamisBildirimler", "")
        .then((res) => {
          // Lisans kontrolü bu istek dönene kadar gelmiş olabilir (T8'in kökü) - o an
          // lisanslıysa sparqonDurum zaten kendi sayısını tutuyor, bayat veriyi yazmayalım.
          if (this.sparqonLisansVar) return;
          if (res?.status === 200 && res.data?.length) {
            this.notifications = res.data.map((item) => this._mapNotif(item));
            this.unreadCount = this.notifications.length;
          } else {
            this.notifications = [];
            this.unreadCount = 0;
          }
        })
        .catch(() => {
          if (this.sparqonLisansVar) return;
          this.notifications = [];
          this.unreadCount = 0;
        });
    },
    openNotifDialog(konum = "right") {
      this.bildirimPanelKonum = konum;
      this.showNotif = false;
      this.bildirimSekme = "tumu";
      this.bildirimlerYukleniyor = true;
      this.allNotifications = [];
      this.okunmamisBildirimler = [];
      this.showNotifDialog = true;
      // Okunmamış sekmesi ayrı uçtan: 200 sınırı yok, Tümü'ne girmeyen eski okunmamışlar da görünür.
      Promise.all([
        this.$Servis("GET", "GetBildirimler", "").catch(() => null),
        this.$Servis("GET", "GetOkunmamisBildirimler", "").catch(() => null),
      ]).then(([tumuRes, okunmamisRes]) => {
        this.allNotifications = tumuRes?.status === 200 && tumuRes.data?.length
          ? tumuRes.data.map((item) => this._mapNotif(item))
          : [];
        this.okunmamisBildirimler = okunmamisRes?.status === 200 && okunmamisRes.data?.length
          ? okunmamisRes.data.map((item) => this._mapNotif(item))
          : [];
        this.bildirimlerYukleniyor = false;
      });
    },
    _mapNotif(item) {
      return bildirimDonustur(item);
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      this.isMobile = this.windowWidth < 960;
      this.RouterView = this.isMobile ? "w-full" : "w-full md:w-10/12";
    },

    async Logout() {
      // KDU K6: gönüllü çıkış sorar; defter yönlendirmeden hemen önce boşaltılır ki
      // reload()/location.href (beforeunload) ikinci kez sormasın.
      if (kirliVarMiHemen() && !(await cikisOnayiAl("sayfa"))) return;
      this.$store
        .dispatch("auth/logout")
        .then(() => {
          // token/user auth/logout'ta (depo) silinir — OT-6: Şirkete geç sekmesinde ortak depoya dokunulmaz
          localStorage.removeItem("rememberedUsername");
          localStorage.removeItem("sirketLogo");
          defteriBosalt();
          this.$router.push({ path: "/auth/login" }).then(() => {
            window.location.reload();
          });
        })
        .catch(() => {
          defteriBosalt();
          window.location.href = "/auth/login";
        });
    },

    // NB planı tetikleyici 3 yardımcısı: sekme görünür olduğunda TTL kontrolü (router afterEach'teki
    // ile aynı mantık, bkz. services/uiState.js menuTtlDoldu). Gizlenirken (visibilitychange→hidden)
    // tetiklenmesin diye visibilityState kontrolü şart.
    _menuOdakKontrol() {
      if (document.visibilityState === "visible" && menuTtlDoldu()) {
        this.ui.menuTazeleGerekli = true;
      }
    },
    _GetNavbar() {
      if (this.menuYukleniyor) return;
      this.menuYukleniyor = true;
      this.$Servis("GET", "GetNavbar", "")
        .then((res) => {
          if (res && res.status === 200) {
            // Sadece ayraçlardan oluşan dizi "dolu" sayılmamalı — lisans filtrelemesiyle bir
            // grubun TÜM gerçek sayfaları elenince geriye DB'deki Seperator=1 işareti tek
            // başına kalabiliyor (ör. lisansı olmayan bir modülün üst başlığı boş görünse de
            // menüde kalıyordu, çünkü {separator:true} tek başı "items.length>0" yapıyordu).
            const gercekIcerikVarMi = (arr) => !!(arr && arr.some((x) => x.separator !== true));

            // url'i olmayan (container) VE görünür/gerçek çocuğu kalmayan düğüm = boş başlık → gizle
            const bosContainer = (node) =>
              node && node.separator !== true && !node.url && !gercekIcerikVarMi(node.items);

            // DE-T1: url yalnız gerçek bir adres varsa set edilir. Boş Url'li konteynerde
            // url:'' kalırsa PrimeVue <a href=""> basıyor ve tıklayınca alt menü açılmak yerine
            // sayfa tamamen yenileniyor (demoda bulundu, DEMO-DEGISIKLIKLERI.md F2).
            const dugum = (label, url, icon) => {
              const d = { label, icon: "pi " + icon };
              const u = this.fixUrl(url);
              if (u) d.url = u;
              return d;
            };

            const temp = [];
            res.data.forEach((v) => {
              if (v.UstMenu == 0) {
                const submenu = res.data
                  .filter((s) => s.UstMenu == v.YetkiYeri_rowid)
                  .map((s) => {
                    const subsubmenu = res.data
                      .filter((ss) => ss.UstMenu == s.YetkiYeri_rowid)
                      .map((ss) => {
                        const subItem = dugum(ss.Tanim, ss.Url, ss.IconAd);
                        if (ss.Seperator === true) return [{ separator: true }, subItem];
                        return subItem;
                      })
                      .flat();

                    const item = dugum(s.Tanim, s.Url, s.IconAd);
                    if (gercekIcerikVarMi(subsubmenu)) item.items = subsubmenu;
                    if (s.Seperator === true) return [{ separator: true }, item];
                    return item;
                  })
                  .flat()
                  .filter((node) => !bosContainer(node));

                const menuItem = dugum(v.Tanim, v.Url, v.IconAd);
                if (gercekIcerikVarMi(submenu)) menuItem.items = submenu;

                // Boş başlık (url yok + gerçek çocuğu yok) menüye eklenmesin
                if (!bosContainer(menuItem)) {
                  if (v.Seperator === true) temp.push({ separator: true });
                  temp.push(menuItem);
                }
              }
            });
            temp.push({ separator: true });
            this.items = temp;
            // Yalnız başarılı dönüşte yazılır (NB planı) — hata/timeout'ta TTL süresi dolmuş
            // sayılmaya devam eder, bir sonraki tetikleyicide tekrar denenir.
            this.ui.menuSonCekim = Date.now();
            this.ui.menuTazeleGerekli = false;
            // Menü tazelendi = lisans durumu da değişmiş olabilir, bedava biniyor (plan §2).
            sessionStorage.removeItem("aktifLisansVar");
            this._yetkiYenidenKontrolEt();
          }
        })
        .catch((err) => console.error("Navbar yükleme hatası:", err))
        .finally(() => { this.menuYukleniyor = false; });
    },
    // Faz 5 (NB planı): menü tazelendikten sonra mevcut sayfanın yetkisi gitmiş olabilir —
    // yalnız GetYetkiKontrol ile kontrol edilir (GetNavbar listesi MenudeGoster=0 sayfaları
    // hiç içermez, ör. /kullanici/ayarlar — o sayfada yanlış yönlendirme yapardı).
    _yetkiYenidenKontrolEt() {
      const path = this.$route.path.toLowerCase();
      if (yetkiYenidenKontrolMuafMi(path, this.$route.fullPath)) return;
      const kontrolEdilenHref = this.$route.href;
      this.$Servis("POST", "GetYetkiKontrol", { URL: kontrolEdilenHref })
        .then((res) => {
          // Yanıt dönene kadar kullanıcı başka bir sayfaya geçmiş olabilir (istek gecikmesi) —
          // eski sayfa için gelen "yetkisiz" yanıtıyla yeni/geçerli sayfadan atmayalım.
          if (res && res.status === 200 && res.data === false && this.$route.href === kontrolEdilenHref) {
            // push değil replace: geçmişte kalan yetkisiz sayfaya geri tuşuyla dönülmesin.
            this.$router.replace("/hata-erisim-yetkisi");
          }
        })
        .catch(() => { /* ağ hatası: fail-open, kullanıcı sayfada kalır */ });
    },

    _KullaniciBilgisi() {
      this.$Servis("GET", "GetKullaniciBilgi_AdRol", "")
        .then((res) => {
          if (res && res.status === 200 && res.data && res.data.length > 0) {
            this.KullaniciBilgi = res.data[0];
          }
        })
        .catch((err) => console.error("Kullanıcı bilgisi yükleme hatası:", err));
    },

    gecerliLogo(v) {
      // Yalnız gerçek bir görsel kaynağı kabul et (bozuk/kısmi decode render'a düşmesin)
      return !!v && (v.startsWith("http") || v.startsWith("data:") || v.startsWith("/"));
    },
    resolveLogo(raw, tip) {
      // Antet deseni: Resim = base64 string, ResimTip = tür. data:image/<tip>;base64,<base64>
      if (!raw) return null;
      const s = String(raw).trim();
      if (!s) return null;
      if (this.gecerliLogo(s)) return s; // zaten data:/http/URL → aynen kullan
      const t = (tip || "png").trim();
      const mime = t.includes("/") ? t : "image/" + (t || "png");
      return "data:" + mime + ";base64," + s; // base64 görseli data URI'ye sar (DECODE ETME)
    },
    onLogoError() {
      // Şirket logosu yüklenemezse paketli logoya düş (tekrar hata verse döngü olmasın)
      if (this.SirketLogo !== this.logoFallback) {
        this.SirketLogo = this.logoFallback;
        try { localStorage.removeItem("sirketLogo"); } catch (e) { /* yok say */ }
      }
    },
    // IBS-2: logo İşletme Bilgileri'nden değişince navbar sayfa yenilenmeden güncellenir (boş = kaldırıldı).
    _LogoDegisti(e) {
      const src = e && e.detail;
      this.SirketLogo = src && this.gecerliLogo(src) ? src : this.logoFallback;
    },
    _GetSirketBilgi() {
      this.$Servis("POST", "GetSirketDigerInfo", {})
        .then((res) => {
          if (res && res.status === 200 && res.data) {
            if (res.data.Resim) {
              const src = this.resolveLogo(res.data.Resim, res.data.ResimTip);
              if (src) {
                this.SirketLogo = src;
                try { localStorage.setItem("sirketLogo", src); } catch (e) { /* kota vs. */ }
              }
            }
            // SK-E2: beyaz etiket bayrağı açıksa sidebar footer'daki "Hepy.app" yerine şirketin kendi adı.
            this.beyazEtiketAcik = res.data.BeyazEtiket === "1";
            this.sirketMarkaAdi = res.data.Ad || "";
          }
        })
        .catch((err) => console.error("Şirket bilgisi yükleme hatası:", err));
    },

    // Faz 1 (2026-09): Sparqon, "AI Panel" (admin ayar/entegrasyon/guardrail ekranları) lisansından
    // AYRILDI — artık iki bağımsız lisans/ürün. aiLisansVar bundan sonra yalnızca "AI Panel" demek;
    // sparqonLisansVar Sparqon paneli/rozeti için ayrı, kesin isim eşleşmesiyle kontrol edilir.
    _AiLisansKontrol() {
      this.$Servis("GET", "GetAktifLisanslarim", "").then((res) => {
        if (res?.status === 200 && Array.isArray(res.data)) {
          // LS3: Kod, ad'dan bağımsız kapı anahtarı - tam eşleşme (ad içinde IndexOf değil).
          this.aiLisansVar = res.data.some((x) => (x.Kod || "").toString().toLowerCase() === "aipanel");
          this.sparqonLisansVar = res.data.some((x) => (x.Kod || "").toString().toLowerCase() === "sparqon");
          this.ui.destekMerkeziVar = res.data.some((x) => (x.Kod || "").toString().toLowerCase() === "destekmerkezi");
          // T8'in kökü: mounted() bu isteği _GetOkunmamisBildirimler'den SONRA baslatiyor, o da
          // henuz false olan sparqonLisansVar ile bir kez yazmis olabilir - lisans true olunca
          // o bayat degeri temizle (bundan sonrasini sparqonDurum'un rozeti tutar).
          if (this.sparqonLisansVar) {
            this.notifications = [];
            this.unreadCount = 0;
          }

          // LS4: bitişine ≤14 gün kalan lisans varsa uyarı şeridi - Basic (TemelMi) her zaman
          // öncelikli (kaybedilirse tüm erişim kapanır), yoksa en az gün kalan modül seçilir.
          const adaylar = res.data.filter((x) => {
            const kg = Number(x.KalanGun);
            return Number.isFinite(kg) && kg <= 14;
          });
          let secilen = null;
          if (adaylar.length) {
            const temelMi = (x) => x.TemelMi === 1 || x.TemelMi === true || x.TemelMi === "1";
            secilen = adaylar.find(temelMi)
              || adaylar.reduce((min, x) => (Number(x.KalanGun) < Number(min.KalanGun) ? x : min), adaylar[0]);
          }
          this.ui.lisansUyari = secilen ? {
            Ad: secilen.Ad,
            Kod: (secilen.Kod || "").toString().toLowerCase(),
            KalanGun: Number(secilen.KalanGun),
            TemelMi: secilen.TemelMi === 1 || secilen.TemelMi === true || secilen.TemelMi === "1",
          } : null;
        }
      }).catch(() => { this.aiLisansVar = false; this.sparqonLisansVar = false; this.ui.destekMerkeziVar = false; });
    },

    // Konsol Faz 1 (SK-0): yalniz nav linkinin görünürlügü icin — gercek erisim kontrolu
    // router guard'da GetSistemKonsolErisim'i ayrica (fail-closed) çağırır.
    _SistemKonsolErisimKontrol() {
      this.$Servis("GET", "GetSistemKonsolErisim", "")
        .then((res) => {
          this.sistemKonsolErisimVar = res?.status === 200 && res.data?.Erisim === true; // SK3-Y: yanıt nesne
        })
        .catch(() => { this.sistemKonsolErisimVar = false; });
    },

    _GetKullaniciProfilBilgi() {
      // Yerel (localStorage) tercih = yedek; DB yalnız BAŞARILI dönerse üzerine yazar.
      // MD-1: KoyuMod NULL = Sistem (telefonun/bilgisayarın teması), 0 = Açık, 1 = Koyu.
      // DB tema kolonları yoksa GET 400 döner → yerel tercihi koru.
      const kayitli = kayitliTema();
      this.$Servis("GET", "GetKullaniciProfilBilgi", "")
        .then((res) => {
          const p = res?.status == 200 ? res?.data?.[0] : null;
          temaUygula(p && "KoyuMod" in p ? temaDbden(p.KoyuMod) : kayitli);
          // AB1: hesaptaki alan boyutu; kolon/yanıt yoksa yerel değer kalır.
          if (p && "AlanBoyutu" in p) boyutUygula(boyutDbden(p.AlanBoyutu));
        })
        .catch((err) => {
          console.error("Profil bilgisi yükleme hatası:", err);
          temaUygula(kayitli);
        });
    },

  },
};
</script>

<style>
.p-tieredmenu-root-item.menu-danger
  > .p-tieredmenu-item-content
  > .p-tieredmenu-item-link,
.p-tieredmenu-item.menu-danger > .p-tieredmenu-item-content > .p-tieredmenu-item-link {
  background-color: color-mix(in srgb, var(--p-red-500) 12%, transparent);
}
.p-tieredmenu-root-item.menu-danger > .p-tieredmenu-item-content > .p-tieredmenu-item-link:hover,
.p-tieredmenu-item.menu-danger > .p-tieredmenu-item-content > .p-tieredmenu-item-link:hover {
  background-color: color-mix(in srgb, var(--p-red-500) 20%, transparent);
}

/* Aktif menu ogesi vurgusu (prototip: turuncu ikon) */
.p-tieredmenu-root-item.menu-active
  > .p-tieredmenu-item-content
  > .p-tieredmenu-item-link,
.p-tieredmenu-item.menu-active > .p-tieredmenu-item-content > .p-tieredmenu-item-link {
  background: var(--type-reformer-bg, #fff7ed) !important;
  border-right: 3px solid var(--studio-orange, #ed7a18);
}
.p-tieredmenu-root-item.menu-active
  > .p-tieredmenu-item-content
  > .p-tieredmenu-item-link
  .p-tieredmenu-item-icon,
.p-tieredmenu-item.menu-active
  > .p-tieredmenu-item-content
  > .p-tieredmenu-item-link
  .p-tieredmenu-item-icon {
  color: var(--studio-orange, #ed7a18) !important;
}

/* Bileşenlerin varsayılan border'larını kaldır — wrapper'lar yönetiyor */
.p-menubar,
.p-tieredmenu {
  border: none !important;
}

/* Admin layout border renkleri açık/koyu temaya uygun */
.admin-border-bottom {
  border-bottom: 1px solid var(--studio-border, #e5e7eb);
}
.dark .admin-border-bottom,
.my-app-dark .admin-border-bottom {
  border-bottom-color: var(--studio-border, #4b5563);
}

.admin-border-right {
  border-right: 1px solid var(--studio-border, #e5e7eb);
}
.dark .admin-border-right,
.my-app-dark .admin-border-right {
  border-right-color: var(--studio-border, #4b5563);
}

.admin-border-top {
  border-top: 1px solid var(--studio-border, #e5e7eb);
}
.dark .admin-border-top,
.my-app-dark .admin-border-top {
  border-top-color: var(--studio-border, #4b5563);
}

/* Dark modda üst navbar (Menubar) beyaz kalmasın — PrimeVue token'ından bağımsız kesin kural */
.dark .p-menubar,
.my-app-dark .p-menubar {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: #1f2937 !important;
}
/* Menubar içindeki slot kapsayıcıları da saydam kalsın (kendi beyaz zemini olmasın) */
.dark .p-menubar-start,
.dark .p-menubar-end,
.dark .p-menubar-root-list,
.my-app-dark .p-menubar-start,
.my-app-dark .p-menubar-end,
.my-app-dark .p-menubar-root-list {
  background: transparent !important;
}

/* ── Dark: Sol menü (sidebar) + TieredMenu — PrimeVue token/Tailwind .dark'a
   bağlı kalmadan kesin. Navbar & içerik .my-app-dark ile koyuya döndüğü halde
   sidebar beyaz kalıyordu (token/utility uygulanmıyor). Aşağısı garanti. ── */
.my-app-dark .admin-sidebar,
.dark .admin-sidebar {
  background: #111827 !important;
}
.my-app-dark .admin-sidebar .admin-search-box,
.dark .admin-sidebar .admin-search-box {
  background: #1f2937 !important;
}
.my-app-dark .admin-sidebar .admin-search-box input,
.dark .admin-sidebar .admin-search-box input {
  color: #e2e8f0 !important;
}
.my-app-dark .admin-sidebar-footer,
.dark .admin-sidebar-footer {
  background: #111827 !important;
}
/* Footer metni (şirket adı + tarih) — PrimeFlex .text-gray-* !important'ını yener */
.my-app-dark .admin-sidebar-footer,
.my-app-dark .admin-sidebar-footer .text-\[11px\],
.dark .admin-sidebar-footer,
.dark .admin-sidebar-footer .text-\[11px\] {
  color: #94a3b8 !important;
}
.my-app-dark .admin-sidebar-footer .font-semibold,
.dark .admin-sidebar-footer .font-semibold {
  color: #e2e8f0 !important;
}

/* TieredMenu (sol menü + mobil popup) koyu */
.my-app-dark .p-tieredmenu,
.dark .p-tieredmenu {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: #1f2937 !important;
}
.my-app-dark .p-tieredmenu-item-link,
.dark .p-tieredmenu-item-link {
  color: #e2e8f0 !important;
}
.my-app-dark .p-tieredmenu-item-icon,
.my-app-dark .p-tieredmenu-item-label,
.dark .p-tieredmenu-item-icon,
.dark .p-tieredmenu-item-label {
  color: #cbd5e1 !important;
}
.my-app-dark .p-tieredmenu-submenu-icon,
.dark .p-tieredmenu-submenu-icon {
  color: #94a3b8 !important;
}
/* hover — aktif öğe (.menu-active) kendi turuncu vurgusunu korur (daha spesifik) */
.my-app-dark .p-tieredmenu-item-content:hover,
.dark .p-tieredmenu-item-content:hover {
  background: #1f2937 !important;
}
.my-app-dark .p-tieredmenu-separator,
.dark .p-tieredmenu-separator {
  border-color: #1f2937 !important;
}

/* TieredMenu alt menülerinin üstte kalmasını sağla */
.p-tieredmenu-submenu,
.p-tieredmenu-overlay {
  z-index: 9999 !important;
}

/* PrimeVue 5 TieredMenu bug'ı: dışarı tıklayınca aria-expanded doğru false'a dönüyor
   ama alt menünün inline "display:flex" stili güncellenmeden takılı kalıyor — sonra
   sidebar'ın kaydırma alanı (overflow-y-auto) onu kırpınca içerik "arkada kalmış" gibi
   görünüyor. aria-expanded (PrimeVue'nun güvenilir şekilde senkron tuttuğu tek işaret)
   üzerinden zorla kapatıyoruz. */
.p-tieredmenu-item[aria-expanded="false"] .p-tieredmenu-submenu {
  display: none !important;
}

/* Transition handled by Tailwind utility classes on the <transition> element */

/* Scroll area: normalde scroll, hover/focus anında overflow kalkar alt menüler kaçar */
.custom-scrollbar {
  overflow: auto;
}
.custom-scrollbar:hover,
.custom-scrollbar:focus-within {
  overflow: visible !important;
}
.custom-scrollbar::-webkit-scrollbar {
  width: 5px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(156, 163, 175, 0.4);
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(156, 163, 175, 0.7);
}
.dark .custom-scrollbar::-webkit-scrollbar-thumb,
.my-app-dark .custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(75, 85, 99, 0.5);
}
.dark .custom-scrollbar::-webkit-scrollbar-thumb:hover,
.my-app-dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(75, 85, 99, 0.8);
}

/* Sayfa geçiş animasyonu (router-view, bkz. yukarıdaki <transition :name="sayfaGecisAdi">).
   AuthLayout.vue'daki "fade" ile aynı isim deseni; süre burada kısa (150ms) — sık
   tetiklenen oturum içi navigasyon, auth ekranının 500ms'i burada yavaş hissettirir.
   prefers-reduced-motion altında `sayfaGecisAdi` "gecis-yok" olur (bkz. data()) — bu
   class'lara karşılık gelen bir CSS kuralı yok, Vue geçişi anında çözer. */
.sayfa-enter-active,
.sayfa-leave-active {
  transition: opacity 0.15s ease-out, transform 0.15s ease-out;
}
.sayfa-enter-from,
.sayfa-leave-to {
  opacity: 0;
  transform: translateY(4px);
}

/* MDK-5: sayfa sonu boşluğu — alt eylem çubuğu / FAB / gezinme çubuğu son satırı örtmesin */
.sayfa-alt-bosluk {
  height: calc(6rem + env(safe-area-inset-bottom, 0px));
}
</style>
